export const currentWeatherConditionsTestIDs = {
  alertsHeadlinesText: 'current_weather_conditions_tile_alerts_headlines_text',
  headerText: 'current_weather_conditions_tile_header_text',
  temperatureText: 'current_weather_conditions_tile_temperature_text',
  feelsLikeText: 'current_weather_conditions_tile_feels_like_text',
  feelsLikeTemperatureText: 'current_weather_conditions_tile_feels_like_temperature_text',
  windText: 'current_weather_conditions_tile_wind_text',
  windContentText: 'current_weather_conditions_wind_content_text',
};
